import axios from "axios";
import { JobPostSummary } from "../../api-types/job-posts";
import { JOB_POSTS_URL, JOB_POSTS_DRAFT_URL } from "../utils";

export const fetchJobPosts = (isDraft: boolean = false) => {
  return axios.get<JobPostSummary[]>(
    isDraft ? JOB_POSTS_DRAFT_URL : JOB_POSTS_URL
  );
};
